class ErrorHandlerService {
    isHandled(err) {
        return err.networkError && err.networkError.shouldIgnore
    }
}

const srv = new ErrorHandlerService()
export default srv
